var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageAccesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51189_145591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0719 5.00001H5.35757V3.57144C5.35757 2.39294 6.32193 1.42857 7.50043 1.42857C8.47909 1.42857 9.32905 2.08567 9.57178 3.02874C9.67188 3.41449 10.0648 3.64292 10.4434 3.54284C10.8291 3.44273 11.0575 3.05004 10.9576 2.67161C10.5504 1.10004 9.12901 0 7.50043 0C5.52898 0 3.92899 1.60017 3.92899 3.57144V5.00001C2.7505 5.00001 1.78613 5.96438 1.78613 7.14287V12.8572C1.78613 14.0357 2.7505 15 3.92899 15H11.0719C12.2504 15 13.2147 14.0357 13.2147 12.8572V7.14287C13.2147 5.96435 12.2504 5.00001 11.0719 5.00001ZM8.21472 10.5214V11.4286C8.21472 11.8213 7.89333 12.1429 7.50043 12.1429C7.10753 12.1429 6.78614 11.8213 6.78614 11.4286V10.5214C6.3575 10.2713 6.07186 9.81445 6.07186 9.2857C6.07186 8.49993 6.71466 7.85713 7.50043 7.85713C8.2862 7.85713 8.929 8.4999 8.929 9.2857C8.929 9.81445 8.64336 10.2713 8.21472 10.5214Z",
    fill: "#8E8E8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51189_145591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAccesIcon);
export default __webpack_public_path__ + "static/media/ManageAccesIcon.ac9923e0100bcf4d6a1d8f61845216be.svg";
export { ForwardRef as ReactComponent };